import { IconButton, Steps, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export namespace HeaderTypes {
  export interface Props {
    canPreviousStep: boolean;
    onPreviousStep: () => void;
    onGoBack: () => void;
    hideSteps?: boolean;
  }
}

export const Header: React.FC<HeaderTypes.Props> = ({
  canPreviousStep,
  onPreviousStep,
  onGoBack,
  hideSteps = false,
}) => {
  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center">
        {canPreviousStep && (
          <IconButton
            testId="withdrawal-header-go-back"
            icon="ArrowLeft"
            iconSize="xxs"
            iconColor={Color['neutral.black']}
            onPress={onPreviousStep}
          />
        )}
        <Text fontWeight="semibold" fontSize={Typography['fontsize.lg']}>
          Novo saque
        </Text>
      </HStack>
      <HStack alignItems="center" space={Spacing['stack.nano']}>
        {!hideSteps && (
          <Steps testId="withdrwal-steps" currentStep={canPreviousStep ? 2 : 1} totalSteps={2} />
        )}
        <IconButton
          testId="withdrawal-header-go-back"
          icon="Close"
          iconSize="xxxxxs"
          iconColor={Color['neutral.black']}
          variant="outline"
          padding={Spacing['inset.nano']}
          borderColor={Color['neutral.black']}
          onPress={onGoBack}
        />
      </HStack>
    </HStack>
  );
};
